import {reactive} from 'vue';

export const store = reactive({
    isLoading: true,
    emptyResult: false,
    setIsLoading(loading) {
        this.isLoading = loading;
        return this;
    },
    labels: [],
    setLabels(labels) {
        this.labels = labels;
        return this;
    },
    current: 0,
    setCurrent(current) {
        this.current = current;
        return this;
    },
    // mock data till data is loaded
    data: {
        blocks: [],
        hasBlocks: false,
        label: ''
    },
    originalData: {
        blocks: [],
        hasBlocks: false,
        label: '',
    },
    filterData() {
        // nothing to filter yet
        if (this.originalData.hasBlocks === false) {
            return;
        }

        let filteredData = {
            blocks: [],
            hasBlocks: false,
            label: this.originalData.label
        }

        /**
         *  copy of blocks and get rid of vuejs proxy. looks weird but it is
         *  the only solution if found to fix the deleted lost elements.
         *  maybe I use vuejs not the right way?!
         * @type array
         */
        let blocks = JSON.parse(JSON.stringify(this.originalData.blocks));


        blocks = blocks.filter((block) => {
            return this.selects.broadcastTimes.selected === '' || this.selects.broadcastTimes.selected === `${block.from} - ${block.to}`;
        });
        blocks = blocks.filter((block) => {
            return this.selects.hosts.selected === '' || this.selects.hosts.selected === block.host;
        });

        blocks.forEach((block) => {
            /**
             *  copy of offers and get rid of vuejs proxy. looks weird but it is
             *  the only solution if found to fix the deleted lost elements.
             *  maybe I use vuejs not the right way?!
             * @type array
             */
            let offers = JSON.parse(JSON.stringify(block.offers));

            offers = offers.filter((offer) => {
                return this.selects.hotelnames.selected === '' || this.selects.hotelnames.selected === offer.hotelname;
            });

            offers = offers.filter((offer) => {
                return this.selects.destinations.selected === '' || this.selects.destinations.selected === offer.destination;
            });

            offers = offers.filter((offer) => {
                return this.selects.orderNumbers.selected === '' || this.selects.orderNumbers.selected === offer.orderNumber;
            });

            // if there are no offers after filtering don't add the block to the list
            if (offers.length < 1) {
                return;
            }

            block.offers = offers;
            block.hasOffers = true;


            filteredData.blocks.push(block);
            filteredData.hasBlocks = true;

        });

        this.emptyResult = (filteredData.blocks.length === 0);
        this.data = filteredData;

        // refill selects after filtering
        this.resetSelectsValues()
            .fillSelects()
            .sortSelects();
    },
    restoreData() {
        this.data = this.originalData;
        return this;
    },
    resetData() {
        this.data = {blocks: [], label: '', hasBlocks: false};
        this.originalData = {blocks: [], label: '', hasBlocks: false};
        this.resetSelectsValues()
            .resetSelectsSelection();
        return this;
    },
    filteredByUser() {
        return this.selects.broadcastTimes.selected !== '' ||
            this.selects.hotelnames.selected !== '' ||
            this.selects.destinations.selected !== '' ||
            this.selects.hosts.selected !== '' ||
            this.selects.orderNumbers.selected !== '';
    },
    resetSelectsValues() {
        this.selects.broadcastTimes.values = [];
        this.selects.hotelnames.values = [];
        this.selects.destinations.values = [];
        this.selects.hosts.values = [];
        this.selects.orderNumbers.values = [];
        return this;
    },
    resetSelectsSelection() {
        this.selects.broadcastTimes.selected = '';
        this.selects.hotelnames.selected = '';
        this.selects.destinations.selected = '';
        this.selects.hosts.selected = '';
        this.selects.orderNumbers.selected = '';
        return this;
    },
    setData(data) {
        this.data = data;
        this.originalData = data;
        this.resetSelectsValues()
            .fillSelects()
            .sortSelects();
        return this;
    },
    fillSelects() {
        this.data.blocks.forEach((block, index) => {
            this.selects.broadcastTimes.values.push(`${block.from} - ${block.to}`);

            if (this.selects.hosts.values.indexOf(block.host) === -1) {
                this.selects.hosts.values.push(block.host);
            }

            block.offers.forEach((offer, index) => {
                if (this.selects.hotelnames.values.indexOf(offer.hotelname) === -1) {
                    this.selects.hotelnames.values.push(offer.hotelname);
                }
                if (this.selects.destinations.values.indexOf(offer.destination) === -1) {
                    this.selects.destinations.values.push(offer.destination);
                }
                if (this.selects.orderNumbers.values.indexOf(offer.orderNumber) === -1) {
                    this.selects.orderNumbers.values.push(offer.orderNumber);
                }
            });

        })
        return this;
    },
    sortSelects() {
        this.selects.hotelnames.values.sort((a, b) => a.localeCompare(b));
        this.selects.destinations.values.sort((a, b) => a.localeCompare(b));
        this.selects.hosts.values.sort((a, b) => a.localeCompare(b));
        this.selects.orderNumbers.values.sort((a, b) => a.localeCompare(b));
        return this;
    },
    selects: {
        broadcastTimes: {
            disabled: false,
            selected: '',
            values: []
        },
        hotelnames: {
            disabled: false,
            selected: '',
            values: []
        },
        destinations: {
            disabled: false,
            selected: '',
            values: []
        },
        hosts: {
            disabled: false,
            selected: '',
            values: []
        },
        orderNumbers: {
            disabled: false,
            selected: '',
            values: []
        },
    }
});

window.SK = window.SK || {};
window.SK.stores = {
    tvProgram: store
};